"use strict";

var cov_1jztd7rz8z = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/tree-blob/useBlob.js";
  var hash = "6076cd1fda1f60339dd1d9605882b6b0adda7a9d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/tree-blob/useBlob.js",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 15
        },
        end: {
          line: 16,
          column: 43
        }
      },
      "1": {
        start: {
          line: 18,
          column: 14
        },
        end: {
          line: 18,
          column: 57
        }
      },
      "2": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 24,
          column: 14
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "4": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 20
        }
      },
      "5": {
        start: {
          line: 26,
          column: 16
        },
        end: {
          line: 28,
          column: 14
        }
      },
      "6": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 13
        }
      },
      "7": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 40,
          column: 33
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 39,
          column: 16
        }
      },
      "9": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 50,
          column: 4
        }
      },
      "10": {
        start: {
          line: 53,
          column: 0
        },
        end: {
          line: 66,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "useBlob",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 16
          }
        },
        loc: {
          start: {
            line: 15,
            column: 3
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 29
          },
          end: {
            line: 20,
            column: 30
          }
        },
        loc: {
          start: {
            line: 20,
            column: 40
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 29
          }
        },
        loc: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 25
          },
          end: {
            line: 30,
            column: 26
          }
        },
        loc: {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 30
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 15
          },
          end: {
            line: 16,
            column: 21
          }
        }, {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 43
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 14
          },
          end: {
            line: 18,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 14
          },
          end: {
            line: 18,
            column: 18
          }
        }, {
          start: {
            line: 18,
            column: 23
          },
          end: {
            line: 18,
            column: 33
          }
        }, {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 56
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 39,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 38,
            column: 8
          }
        }, {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 39,
            column: 14
          }
        }],
        line: 31
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 31,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 12
          },
          end: {
            line: 31,
            column: 16
          }
        }, {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 23
          }
        }],
        line: 31
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "6076cd1fda1f60339dd1d9605882b6b0adda7a9d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _ = require(".");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function useBlob(_ref) {
  var config = _ref.config,
      __blob = _ref.blob,
      onBlob = _ref.onBlob,
      repository = _ref.repository,
      tree = _ref.tree,
      _url = _ref.url;
  cov_1jztd7rz8z.f[0]++;
  var blob = (cov_1jztd7rz8z.s[0]++, (cov_1jztd7rz8z.b[0][0]++, __blob) && (cov_1jztd7rz8z.b[0][1]++, (0, _deepFreeze.default)(__blob)));
  var url = (cov_1jztd7rz8z.s[1]++, (cov_1jztd7rz8z.b[1][0]++, _url) || (cov_1jztd7rz8z.b[1][1]++, repository) && (cov_1jztd7rz8z.b[1][2]++, repository.tree_url));
  var update = (cov_1jztd7rz8z.s[2]++, (0, _react.useCallback)(function (_blob) {
    cov_1jztd7rz8z.f[1]++;
    cov_1jztd7rz8z.s[3]++;

    if (onBlob) {
      cov_1jztd7rz8z.b[2][0]++;
      cov_1jztd7rz8z.s[4]++;
      onBlob(_blob);
    } else {
      cov_1jztd7rz8z.b[2][1]++;
    }

    ;
  }, [onBlob]));
  var close = (cov_1jztd7rz8z.s[5]++, (0, _react.useCallback)(function () {
    cov_1jztd7rz8z.f[2]++;
    cov_1jztd7rz8z.s[6]++;
    update();
  }, [update]));
  var browse = (cov_1jztd7rz8z.s[7]++, (0, _react.useMemo)(function () {
    cov_1jztd7rz8z.f[3]++;
    cov_1jztd7rz8z.s[8]++;
    return (cov_1jztd7rz8z.b[4][0]++, tree) || (cov_1jztd7rz8z.b[4][1]++, url) ? (cov_1jztd7rz8z.b[3][0]++, /*#__PURE__*/_react.default.createElement(_.Tree, {
      tree: tree,
      url: url,
      config: config,
      selected: true,
      onBlob: update
    })) : (cov_1jztd7rz8z.b[3][1]++, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  }, [tree, url, config, update]));
  cov_1jztd7rz8z.s[9]++;
  return {
    state: blob,
    actions: {
      close: close,
      update: update
    },
    component: browse,
    components: {
      browse: browse
    }
  };
}

;
cov_1jztd7rz8z.s[10]++;
useBlob.propTypes = {
  /** An array of paths from the Gitea file tree api. */
  tree: _propTypes.default.arrayOf(_propTypes.default.shape({
    path: _propTypes.default.string.isRequired,
    type: _propTypes.default.oneOf(['tree', 'blob']).isRequired
  })),

  /** The Url to fetch the listing if listing is not provided. */
  url: _propTypes.default.string,

  /** Repository tree_url can be used in place of blobConfig */
  repository: _propTypes.default.shape({
    /** The Url to fetch the listing if listing is not provided. */
    tree_url: _propTypes.default.string.isRequired
  })
};
var _default = useBlob;
exports.default = _default;